import { ConfirmDataLossService } from '@vfde-fe/ngx-lib/services/confirm-data-loss';
import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { OrderDetailsActionTypes, OrderDetailsRequest, OrderDetailsSuccess, OrderDetailsFaliure, OrderDetailsMoreInfo } from '../actions/order-details.action';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { LoginService } from '../../landing-page/login/login.service';
import { of } from 'rxjs';
import { LOGIN_ERROR_CODES } from 'src/app/common/constants/defines';
import { RoutingAction } from '../actions/routing.action';
import * as pagesConfig from '../../../config/pages-config';
import { OrderDetailedService } from 'src/app/shared/services/order-details.service';
import { ChangeOrder, RemoveBeforeUnloadListener, SetUserCredentials, SetRefreshUserData, RemoveForwardToAgent } from '../actions/order-details-extend.actions';
import { config } from '../../../config/pages-config';
/** OrderDetailsEffects */
@Injectable()
export class OrderDetailsEffects {
    /** URL */
    public url;
    /** overview_config */
    public overview_config = config.overview;
    /** customErrorHandlerService */
    public customErrorHandlerService: any;
    /** orderDetailsLoaded */
    @Effect()
    public orderDetailsLoaded = this.actions.pipe(ofType<OrderDetailsRequest>(OrderDetailsActionTypes.LOAD_ORDER_DETAILS_REQUEST),
        mergeMap(
            ac =>
                this.loginService.getMappedOrderDetails(ac.payload.userCredentials).pipe(mergeMap(orderDerailsData => {
                    if (this.loginService.cleanUpNoReturnsEntitledSimEsimOnlyFlag) {
                        return of(new RoutingAction({ url: pagesConfig.config.generalError.route}));
                    } else {
                        return [new RoutingAction({ url: pagesConfig.config.overview.route }), new OrderDetailsSuccess({
                            delivery: orderDerailsData,
                            loggedIn: true,
                            moreInfo: false,
                        }), new SetUserCredentials({
                            userCredentials: ac.payload.userCredentials,
                        })];
                }
            }), catchError((err) => {
                    try {
                        const status = err.status;

                        const error = err.error;
                        if (status == LOGIN_ERROR_CODES.MORE_INFO_CODE.STATUS && error.faultMessage.code === LOGIN_ERROR_CODES.MORE_INFO_CODE.CODE) {
                            return of(new OrderDetailsMoreInfo({
                                loggedIn: false,
                                moreInfo: true,
                            }));
                        } else {
                            const errorObj = {
                                code: error.faultMessage.code,
                                status: status,
                            };

                            return of(new OrderDetailsFaliure({ errrObject: errorObj, loggedIn: false, moreInfo: false }));
                        }
                    } catch {

                        return of(new RoutingAction({ url: pagesConfig.config.generalError.route}));
                    }
                }))));
/** changeOrder$ */
        @Effect()
        public changeOrder$ = this.actions.pipe(
            ofType<ChangeOrder>(OrderDetailsActionTypes.CHANGE_ORDER),
            mergeMap(action => this.orderDetailedService.changeOrder(action.payload).pipe(mergeMap(
                (navigationData) => {
                    if (navigationData) {

                        const actionsToBeDispatched = [new SetRefreshUserData({refreshUserData: true}), new RemoveForwardToAgent(), new RoutingAction({                            url: navigationData.urlForSuccess,
                            targetUrl: navigationData.targetUrl,
                        })];
                        !navigationData.urlForSuccess && actionsToBeDispatched.pop();

                        return actionsToBeDispatched;
                    }
                },
            ) , catchError((error) => {

                    return of({type: OrderDetailsActionTypes.NO_ACTIONS});
                }),
            )));
/** removeBeforeUnloadListener$ */
    @Effect({ dispatch: false })
    public removeBeforeUnloadListener$ = this.actions.pipe(
        ofType<RemoveBeforeUnloadListener>(OrderDetailsActionTypes.REMOVE_BEFORE_UNLOAD_LISTENER),
        map(action => this.confirmDataLossService.removeListener()));
    /**
     *
     * @param actions
     * @param loginService
     * @param orderDetailedService
     * @param confirmDataLossService
     */
    public constructor (public actions: Actions, public loginService: LoginService, private orderDetailedService: OrderDetailedService,
        private confirmDataLossService: ConfirmDataLossService) { }

}
